/**
 * Created by andrey on 02.08.2022.
 */

const BackToAdminOrEditorAction = function (f) {
    const params = cleverapps.getRequestParameters(location.hash);
    if (params.mode === "editor") {
        cleverapps.setUrlHash({ playLevel: undefined });

        this.level.edit(f);
        return true;
    }

    if (params.mode === "admin") {
        cleverapps.setUrlHash({ playLevel: undefined });

        AdministratorScene.open(f);
        return true;
    }
    return false;
};

BackToAdminOrEditorAction.isTestPlay = function () {
    const params = cleverapps.getRequestParameters(location.hash);
    return params.playLevel && ["admin", "editor"].includes(params.mode);
};